module.exports = __webpack_public_path__ + "static/media/bro.d1b2f4bb.mp3";